import { render, staticRenderFns } from "./Auth0Login.vue?vue&type=template&id=c0016382&"
import script from "./Auth0Login.vue?vue&type=script&lang=js&"
export * from "./Auth0Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports